<template>
  <div class="reject-dialog">
    <div class="reject-header">
      <h3 class="reject-title">{{ t('interview.rejectDialogTitle') }}</h3>
      <span class="reject-close" @click="handleClose">×</span>
    </div>
    <div class="reject-content">
      <textarea
        v-model="reason"
        class="reject-textarea"
        :placeholder="t('interview.rejectReasonPlaceholder')"
        rows="4"
      />
    </div>
    <div class="reject-footer">
      <button class="reject-button reject-button-default" @click="handleCancel">
        {{ t('interview.cancelButton') }}
      </button>
      <button class="reject-button reject-button-danger" @click="handleConfirm">
        {{ t('interview.rejectButton') }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import type { RejectDialogProps } from './reject-types';

const { t } = useI18n();

const props = defineProps<RejectDialogProps>();

const emit = defineEmits<{
  cancel: [];
  confirm: [reason: string];
  close: [];
}>();

const reason = ref('');

const handleCancel = () => {
  emit('cancel');
};

const handleConfirm = async () => {
  emit('confirm', reason.value);
};

const handleClose = () => {
  emit('close');
};
</script>

<style lang="scss" scoped>
.reject-dialog {
  min-width: 516px;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
}

.reject-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px 30px 20px;
}

.reject-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #101729;
}

.reject-close {
  font-size: 24px;
  line-height: 1;
  color: #8c8c8c;
  cursor: pointer;
  transition: color 0.3s;

  &:hover {
    color: #262626;
  }
}

.reject-content {
  padding: 0px 30px;
}

.reject-textarea {
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  line-height: 22px;
  color: #101729;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  outline: none;
  resize: vertical;
  font-family: inherit;
  transition: border-color 0.3s;

  &::placeholder {
    color: #bfbfbf;
  }

  &:hover {
    border-color: var(--el-color-primary);
  }

  &:focus {
    // border-color: #4096ff;
    box-shadow: 0 0 0 2px rgba(64, 150, 255, 0.1);
  }
}

.reject-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px 30px;
}

.reject-button {
  min-width: 72px;
  height: 32px;
  padding: 4px 16px;
  font-size: 14px;
  line-height: 22px;
  border-radius: 4px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.3s;
  outline: none;

  &:active {
    transform: translateY(1px);
  }
}

.reject-button-default {
  background: #ffffff;
  border-color: #d9d9d9;
  color: #262626;

  &:hover {
    // border-color: #4096ff;
    color: #4096ff;
  }
}

.reject-button-danger {
  background: #ff4d4f;
  color: #ffffff;

  &:hover {
    background: #ff7875;
  }
}
</style>
